import React, { useState } from 'react';
import { useCart } from '@montana/containers/cart';
import { Button, ButtonStyles } from '@montana/shared/button';
import { Translate } from '@montana/shared/translate';
import { formatString } from '@montana/helpers/string-format/string-format.helper';
import { Price } from '@montana/shared/price';
import { IAppCartLine } from '@montana/containers/cart/cart';
import { Link } from '@montana/shared/link';
import { ProductImage } from '@montana/shared/product-image/product-image.component';

export interface IMiniCartLineProps {
    productLine: IAppCartLine;
}

export const MiniCartLine: React.FC<IMiniCartLineProps> = React.memo((props: IMiniCartLineProps): JSX.Element => {
    const { productLine } = props;
    const [isHoveringOnRemove, setIsHoveringOnRemove] = useState(false);
    const { reinstateCartLine, updateQuantityLoading } = useCart();

    const cancelRemoveFromCart = (): void => {
        if (productLine.productGroupId) {
            reinstateCartLine(productLine.productGroupId);
        }
    };

    const removeOnMouseEnter = (): void => {
        setIsHoveringOnRemove(true);
    };

    const removeOnMouseLeave = (): void => {
        setIsHoveringOnRemove(false);
    };

    return (
        <div className="mini-cart-line">
            <Link to={productLine.productUrl || undefined} className="mini-cart-line__image">
                <ProductImage
                    productImage={productLine.productImageViewModel}
                    name={productLine.name}
                    ariaHidden={true}
                    sizes="70px"
                />
            </Link>

            <div className="mini-cart-line__text">
                <Link to={productLine.productUrl || undefined}>
                    <h3 className="mini-cart-line__name">{`${productLine.quantity}x ${productLine.name}`}</h3>
                    <p className="mini-cart-line__price">
                        <span className={productLine.discount?.amount ? 'mini-cart-line__price--current' : ''}>
                            <Price obj={productLine.price} />
                        </span>
                        {!!productLine.discount?.amount && (
                            <span className="mini-cart-line__price--before">
                                <Price obj={productLine.priceWithoutDiscount} />
                            </span>
                        )}
                    </p>
                    {!!productLine.discount?.amount && (
                        <p className="mini-cart-line__savings">
                            <Translate value={(t): string => t.miniBasket.save} defaultValue="Save" />
                            &nbsp;
                            <Price obj={productLine.discount} />
                        </p>
                    )}
                </Link>
                {/* NOTE: Removal of items in mini cart should not be a feature */}
                {/* <Button className="mini-cart-line__remove" onClick={(): void => removeFromCart()} style={ButtonStyles.Text}>
                    <Translate value={(t): string => t.miniBasket.remove} defaultValue="Remove" />
                </Button> */}
            </div>
            {
                (productLine.pendingDeletion || isHoveringOnRemove) && (
                    <div className="mini-cart-line__removing-screen">
                        <p>
                            <Translate value={(t): string => t.miniBasket.removedFromShoppingBag} defaultValue="{0} was removed from your shopping bag">
                                {(t): string => formatString(t, `${productLine.name}`)}
                            </Translate>
                        </p>
                        <div onMouseEnter={(): void => removeOnMouseEnter()} onMouseLeave={(): void => removeOnMouseLeave()}>
                            <Button disabled={updateQuantityLoading} className="tracking-wider" onClick={(): void => cancelRemoveFromCart()} style={ButtonStyles.Text}>
                                <Translate value={(t): string => t.miniBasket.getItBack} defaultValue="Get it back" />
                            </Button>
                        </div>
                    </div>
                )
            }
        </div>
    );
});
